export default [
  {
    path: '/novidades',
    name: 'novidades',
    component: () => import('@/views/news/NewsPanel.vue'),
  },
]
